import { IconProps } from '@models/icons';

function DownloadIcon(props:IconProps) {
  return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...props} >
            <path
                d="M14.9999 18.6557L14.9999 6M14.9999 18.6557L17.4311 16.2246L18.1611 15.4945M14.9999 18.6557L12.5688 16.2246L11.8387 15.4945"
                stroke="var(--color-gray5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M6.48108 9.55548C5.27424 9.55548 4.2959 10.5338 4.2959 11.7407V21.4073C4.2959 23.0642 5.63904 24.4073 7.2959 24.4073H14.9996H22.5133C24.2751 24.4073 25.7033 22.9791 25.7033 21.2173V11.7407C25.7033 10.5338 24.725 9.55548 23.5181 9.55548H19.5552C19.0029 9.55548 18.5552 10.0032 18.5552 10.5555C18.5552 11.1078 19.0029 11.5555 19.5552 11.5555H23.5181C23.6204 11.5555 23.7033 11.6384 23.7033 11.7407V21.2173C23.7033 21.8746 23.1705 22.4073 22.5133 22.4073H14.9996H7.2959C6.74362 22.4073 6.2959 21.9596 6.2959 21.4073V11.7407C6.2959 11.6384 6.37881 11.5555 6.48108 11.5555H10.444C10.9963 11.5555 11.444 11.1078 11.444 10.5555C11.444 10.0032 10.9963 9.55548 10.444 9.55548H6.48108Z"
                  fill="var(--color-gray5)"/>
        </svg>
  );
}

export default DownloadIcon;
